import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ShowOnDirtyErrorStateMatcher } from '@angular/material/core';
import { IFebActiviteUoNomenclature } from 'src/app/shared/models/feb-activite-uo-nomenclature';
import { FebActiviteUoNomenclatureService } from '../feb-activite-uo-nomenclature.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';

@Component({
  selector: 'app-feb-activite-uo-nomenclature-dialog',
  templateUrl: './feb-activite-uo-nomenclature-dialog.component.html',
  styleUrls: ['./feb-activite-uo-nomenclature-dialog.component.less']
})
export class FebActiviteUoNomenclatureDialogComponent {
  formGroup: UntypedFormGroup;
  isEditMode: boolean;

  readonly matcher = new ShowOnDirtyErrorStateMatcher();
  errorMessage: string | null = null;

  constructor(
    private _fb: UntypedFormBuilder,
    private febActiviteUoNomenclatureService: FebActiviteUoNomenclatureService,
    private snackbarService: SnackbarService,
    public dialogRef: MatDialogRef<FebActiviteUoNomenclatureDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IFebActiviteUoNomenclature | null
  ) {
    this.isEditMode = data != null;

    this.formGroup = this._fb.group({
      activiteUOoperationnelle: [data?.activiteUOoperationnelle ?? '', [
        Validators.required,
        Validators.pattern(/\S+/),
        Validators.maxLength(100)
      ]],
      nomenclatureLabel: [data?.nomenclatureLabel ?? '', [
        Validators.required,
        Validators.pattern(/\S+/),
        Validators.maxLength(100)
      ]],
      prixUO: [data?.prixUO ?? null, [
        Validators.required,
        Validators.min(0),
        Validators.pattern(/^\d+(\.\d{1,2})?$/)
      ]],
      prixUOmajore: [data?.prixUOmajore ?? null, [
        Validators.required,
        Validators.min(0),
        Validators.pattern(/^\d+(\.\d{1,2})?$/)
      ]]
    });

    this.formGroup.valueChanges.subscribe(() => {
      this.errorMessage = null;
    });
  }

  onSubmit(): void {
    if (this.formGroup.invalid) return;

    if (!this.isEditMode) {
      this.febActiviteUoNomenclatureService.create(this.formGroup.value).subscribe({
        next: (created) => {
          this.snackbarService.openSnackBar('Nomenclature créée avec succès');
          this.dialogRef.close(created);
        },
        error: (errFn) => {
          const err = typeof errFn === 'function' ? errFn() : errFn;
          const msg = err?.error?.message ?? 'Erreur lors de la création de la nomenclature';
          this.errorMessage = msg;
          this.snackbarService.openSnackBar(msg, 'error-snack-bar');
        }
      });
    } else {
      this.febActiviteUoNomenclatureService
        .update(this.data!.id ?? this.data!.nomenclatureId ?? '', this.formGroup.value)
        .subscribe({
          next: (updated) => {
            this.snackbarService.openSnackBar('Nomenclature modifiée avec succès');
            this.dialogRef.close(updated);
          },
          error: (errFn) => {
            const err = typeof errFn === 'function' ? errFn() : errFn;
            const msg = err?.error?.message ?? 'Erreur lors de la modification de la nomenclature';
            this.errorMessage = msg;
            this.snackbarService.openSnackBar(msg, 'error-snack-bar');
          }
        });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}